import { Anchors } from "@/lib/routes";

export const navLinks = [
  { id: 1, name: "О нас", href: `/${Anchors.ABOUT}` },
  { id: 2, name: "Услуги", href: `/${Anchors.SERVICES}` },
  { id: 3, name: "Проекты", href: `/${Anchors.PROJECTS}` },
  { id: 4, name: "Клиенты", href: `/${Anchors.CLIENTS}` },
  { id: 5, name: "Контакты", href: Anchors.CONTACTS },
] as const;
